'use client';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { useCarouselContext } from '@eliadmin/core/src/components/ui/carousel-context';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { CarouselProgress } from '../ui/carousel-progress';
import { CarouselControls } from '@eliadmin/core/src/components/ui/carousel-controls';
import { Carousel } from '@eliadmin/core/src/components/ui/carousel';
import { ReferenceCard } from '../reference/reference-card';
import { CarouselWall } from '../ui/carousel-wall';
import { GoArrowLeft, GoArrowRight } from 'react-icons/go';

export function LatestReferences({ references }: { references: Reference[] }) {
  const options = {
    align: 'start' as const,
  };

  const carouselContext = useCarouselContext();

  if (!carouselContext) {
    throw new Error('Hero must be used within a CarouselProvider');
  }

  const { selectedIndex } = carouselContext;

  return (
    <section
      className={cn(
        'custom-section',
        'gap-8 bg-[#FFFAF4] py-12 sm:gap-10 sm:py-16 lg:gap-12 lg:py-[120px]',
      )}
    >
      <div className={cn('custom-container', 'flex items-center justify-between gap-4')}>
        <h2 className="font-oswald text-3xl font-medium uppercase text-black sm:text-4xl lg:text-5xl">
          Posledné realizácie
        </h2>
        <CarouselControls
          className={{
            main: 'hidden gap-2 sm:flex',
            button: 'h-12 w-12 rounded-none border-none bg-primary shadow-none hover:bg-primary/90',
          }}
          nextIcon={<GoArrowRight size={24} className="text-white" />}
          prevIcon={<GoArrowLeft size={24} className="text-white" />}
        />
      </div>
      <div className={cn('custom-container', 'relative overflow-visible')}>
        <CarouselWall className="bg-[#FFFAF4]" />
        <Carousel
          options={options}
          className={{
            slide: 'w-full max-w-[340px] sm:max-w-[420px] md:max-w-[460px] lg:max-w-[620px]',
            wrapper: 'w-full overflow-visible',
            container: 'w-full gap-4 overflow-visible sm:gap-5 lg:gap-6',
            main: 'w-full overflow-visible',
          }}
          slides={references.map(reference => (
            <ReferenceCard reference={reference} key={reference?.slug} />
          ))}
        />
      </div>
      <div
        className={cn('custom-container', 'flex items-center justify-between gap-4 pr-4 sm:hidden')}
      >
        <CarouselProgress selectedIndex={selectedIndex} totalSlides={references?.length} />
        <CarouselControls
          className={{
            main: 'flex gap-2',
            button:
              'max-h-10 min-h-10 min-w-10 max-w-10 rounded-none border-none bg-primary shadow-none hover:bg-primary/90',
          }}
          nextIcon={<GoArrowRight size={20} className="text-white" />}
          prevIcon={<GoArrowLeft size={20} className="text-white" />}
        />
      </div>
    </section>
  );
}
